import React from 'react';
import { connect } from 'react-redux';
// Components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
// ressources
import styles from './error-boundary-wrapper-style';
import { rootActions } from '../../redux/actions';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { getHistory } from '../../utils/historyUtils';

interface ErrorBoundaryProps extends WithStyles {
    children: JSX.Element;
    clearRootState: () => any;
}

interface ErrorBoundaryState {
    hasError: boolean;
    errorInfos: any;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = {
            hasError: false,
            errorInfos: undefined,
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, errorInfos: error };
    }

    componentDidCatch(error, info) {
        // future logEvent
    }

    clearRootState = (): void => {
        const { clearRootState } = this.props;
        const history = getHistory();
        clearRootState();
        history.goBack();
    };

    renderErrorContent = (): JSX.Element => {
        const { classes } = this.props;
        return (
            <Grid container spacing={2} justifyContent="center">
                <div className={classes.root}>
                    <Typography variant="h4" component="h4">
                        Une erreur s'est produite !!
                    </Typography>
                    <div className={classes.buttonContainer}>
                        <Button variant="contained" color="secondary" onClick={this.clearRootState}>
                            {'Retour'}
                        </Button>
                    </div>
                </div>
            </Grid>
        );
    };

    render() {
        const { hasError } = this.state;

        if (hasError) {
            return this.renderErrorContent();
        }

        return this.props.children;
    }
}

const mapDispatchToProps = {
    clearRootState: rootActions.clearRootState,
};

const ErrorBoundaryStyled = withStyles(styles)(ErrorBoundary);

export default connect(null, mapDispatchToProps)(ErrorBoundaryStyled);
